import { HorizontalAlignType, PaletteColorType, PositionType, TextStyleType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class TitleCategory extends BaseCategory {
    get name() {
        return "Title";
    }

    get type() {
        return SlideCategories.TITLE;
    }

    get icon() {
        return null;
    }

    get description() {
        // return "Only choose if this is the first slide AND the content includes the title of the presentation and optionally, a subtitle or presenter names.";
        return "The content includes the title of the presentation and optionally, a subtitle or presenter names.";
    }

    getPrompt() {
        return `Create a title slide for the presentation. 
                Include the main title of the presentation, and optionally a subtitle. 
                Include presenter names or titles if provided in the userinput.
                Include the company, organization or logo if provided in the userinput.`;
    }

    getPromptSchema() {
        return {
            presenters: [{
                name: "the name of a presenter",
                title: "the title or role of the presenter"
            }],
            companyName: "the name of the company, organization or logo. Leave empty if none",
        };
    }

    getSlideModels(model) {
        let models = [
            this.buildTitle(model, true, PositionType.TOP),
            this.buildTitle(model, true, PositionType.LEFT),
            this.buildTitle(model, false, PositionType.BACKGROUND),
        ];

        return models;
    }

    buildTitle(model, showImage, imagePosition) {
        let builder = new SlideModelBuilder("title", model);

        let primary = {
            showFooter: false,
            showPresenters: model.presenters && model.presenters.length > 0,
            image: builder.createImage(model.slideImage?.prompt, { position: imagePosition }, true),
            backdropStyle: "white_box",
            backdropColor: PaletteColorType.BACKGROUND_LIGHT,
            textAlign: imagePosition == PositionType.LEFT ? HorizontalAlignType.LEFT : HorizontalAlignType.CENTER,
            textPosition: imagePosition == PositionType.LEFT ? HorizontalAlignType.LEFT : HorizontalAlignType.CENTER,

            text: {
                blocks: [
                    builder.createBlock(model.slideTitle, TextStyleType.HEADING),
                    builder.createBlock(model.slideSubTitle, TextStyleType.BODY),
                ].filter(b => b)
            },
        };

        // Add presenters if they exist in the model
        if (model.presenters && model.presenters.length > 0) {
            primary.presenters = {
                items: model.presenters.map(presenter => ({
                    text: {
                        blocks: [
                            builder.createBlock(presenter.name, TextStyleType.TITLE),
                            builder.createBlock(presenter.title, TextStyleType.BODY),
                        ].filter(b => b)
                    }
                }))
            };
        }

        // Add logos if they exist in the model
        // if (model.companyName) {
        //     primary.logos = {
        //         items: [{
        //             ...builder.createLogo(model.companyName, { showBackdrop: true })
        //         }]
        //     };
        // }

        builder.createPrimary(primary);
        return builder.model;
    }
}

